import * as hyejoo from './hyejoo';

export const {
    getAll: GetCarriers,
    get: GetCarrier,
} = hyejoo.Getters('/carriers', (resp: hyejoo.Carriers) => resp.carriers);